import { Check, Palette } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export function ThemeSwitcher({ compact = false }) {
  const { theme, setTheme, themes } = useTheme();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size={compact ? "icon" : "sm"}
          className="gap-1.5"
          data-testid="theme-switcher-button"
          aria-label="Change interface theme"
        >
          <Palette className="h-4 w-4" />
          {!compact && <span className="hidden text-xs sm:inline">Theme</span>}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-72" data-testid="theme-switcher-menu">
        <DropdownMenuLabel className="text-xs">Interface theme</DropdownMenuLabel>
        {themes.map((t) => (
          <DropdownMenuItem
            key={t.id}
            data-testid={`theme-option-${t.id}`}
            onClick={() => setTheme(t.id)}
            className="flex cursor-pointer items-center gap-3 py-2"
          >
            <span className="flex shrink-0 overflow-hidden rounded-full ring-1 ring-border">
              {t.swatch.map((c) => (
                <span key={c} className="h-5 w-3" style={{ background: c }} />
              ))}
            </span>
            <span className="min-w-0 flex-1">
              <span className="block truncate text-sm font-medium">{t.name}</span>
              <span className="block truncate text-[11px] text-muted-foreground">{t.tagline}</span>
            </span>
            {theme === t.id && <Check className="h-4 w-4 shrink-0 text-primary" data-testid={`theme-active-${t.id}`} />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
